export default __webpack_public_path__ + "assets/images/d93caf9105ea64c22ac0ac77f6099de4.png";